import moment from "moment";
import YAML from "yaml";
import { Box, Typography, useTheme } from "@mui/material";
import { ArrowForward, Done } from "@mui/icons-material";
import StatusChip from "../../components/StatusChip";
import { timeFormat } from "../../utils/constants";
import { getTimeZoneAbbreviation } from "../../utils/dateUtils";
import { tokens } from "../../theme";
import { vulnerabilityDrawerStyles as styles } from "./styles";

// Timeline icon tints (portal): green check for administer, blue arrow for request.
const ADMINISTERED_ICON = (c) => ({
  bg: c.okBg,
  border: c.isDark ? c.okFg : "#91DA92",
  fg: c.okText,
});
const REQUESTED_ICON = (c) => ({
  bg: c.tint,
  border: c.linkSoft,
  fg: c.link,
});

const HistoryItem = ({ icon, label, date, colors }) => (
  <Box sx={styles.historyItem}>
    {icon}
    <Box>
      <Typography sx={styles.historyName(colors)}>{label}</Typography>
      <Typography sx={styles.historyDate(colors)}>{`${moment(date)?.format(
        timeFormat
      )} ${getTimeZoneAbbreviation()}`}</Typography>
    </Box>
  </Box>
);

const DetailPanelContent = ({ row }) => {
  const theme = useTheme();
  const colors = tokens(theme.paletteId);

  const severity = row?.metaData?.Severity || row?.metaData?.level;

  return (
    <Box>
      <Box sx={styles.badgeRow}>
        <StatusChip value={row?.status} />
        {severity ? (
          <StatusChip value={`${severity} SEVERITY`.toUpperCase()} />
        ) : null}
      </Box>
      <Typography sx={styles.sectionLabel(colors)}>
        Vulnerability Details
      </Typography>
      <Box sx={styles.metaBlock(colors)}>
        {YAML.stringify(row?.metaData, null, 4)}
      </Box>
      {(row?.administeredBy || row?.requestedBy) && (
        <>
          <Typography sx={styles.sectionLabel(colors)}>
            Approval History
          </Typography>
          <Box sx={styles.historyList}>
            {row?.administeredBy && (
              <HistoryItem
                colors={colors}
                icon={
                  <Box sx={styles.historyIcon(ADMINISTERED_ICON(colors))}>
                    <Done sx={{ fontSize: 14 }} />
                  </Box>
                }
                label={`Administered by ${row?.administeredBy?.split("@")[0]}`}
                date={row?.dateAdministered}
              />
            )}
            {row?.requestedBy && (
              <HistoryItem
                colors={colors}
                icon={
                  <Box sx={styles.historyIcon(REQUESTED_ICON(colors))}>
                    <ArrowForward sx={{ fontSize: 13 }} />
                  </Box>
                }
                label={`Requested by ${row?.requestedBy?.split("@")[0]}`}
                date={row?.dateRequested}
              />
            )}
          </Box>
        </>
      )}
    </Box>
  );
};
export default DetailPanelContent;
